export enum EngagementVisibility {
    Public = 1,
    Hidden = 2,
    Internal = 3,
}
